import React, { Component } from "react";

export default class ZoomPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: this.props.url,
    };
  }
  render() {
    return (
      <div className="embed-responsive embed-responsive-16by9">
        <iframe title="ZoomMeet" src={this.state.url}>
          <p>Your browser dont support iFrame</p>
        </iframe>
      </div>
    );
  }
}
